module.exports = __webpack_public_path__ + "static/media/certificatesDesktop.83ad4b1a.png";